import { useContext, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'

import CardAccess from '../components/CardAccess';
import { Data } from '../interfaces/ICardAccess';
import { authenticationService } from '../service/AuthAction';

import '../sass/accessPage.sass';
import { AuthContext } from '../service/AuthProvider';

const LoginPage = () => {

    const { dispatch } = useContext(AuthContext)

    const history = useHistory();

    // useEffect(()=>{
    //     const json = localStorage.getItem('user');
    //     const redirectCourse = localStorage.getItem('redirectCourse')
    //     if( json ) {
    //         if (redirectCourse) {
    //             return history.push(redirectCourse)
    //         }
    //         return history.push('/dashboard');
    //     }
    // },[history])

    let data: Data = {
        title: "Iniciar sesión como: ",
        name: "Estudiante",
        info: "Para ingresar a la plataforma debe poner sus credenciales de acceso.",
    }

    const [user, setUser] = useState({ email: '', password: '' });
    const [lookpass, setLookPass] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);

    const { email, password } = user;

    const onChangeInputs = (e: any) => setUser({ ...user, [e.target.name]: e.target.value })

    const onSubmit = async (e: any) => {
        e.preventDefault();
        setLoading(true);
        await authenticationService( email, password, history, setLoading, dispatch );
        // setLoading(false);
    }

    return (
        <div className="main_AccessPage">
            <CardAccess data={data}>
                <form onSubmit={onSubmit} >
                    <div className="formBody" >
                        <label htmlFor="accessUser">
                            <input
                                id="accessUser"
                                type="email"
                                name='email'
                                placeholder="Ingrese su correo"
                                value={email}
                                onChange={onChangeInputs}
                                disabled={loading}
                                required />
                        </label>
                        <span><Link to="/auth/recover-password">¿Olvidó su contraseña?</Link></span>
                        <label htmlFor="accessPass">
                            <input
                                id="accessPass"
                                className="inpPass"
                                type={`${lookpass ? 'text' : 'password'}`}
                                placeholder="Contraseña"
                                name='password'
                                value={password}
                                onChange={onChangeInputs}
                                disabled={loading}
                                required
                            />
                            <i className={`far fa-eye${lookpass ? '-slash' : ''}`} onClick={() => setLookPass(!lookpass)} />
                        </label>
                    </div>
                    <div className="formFooter">
                        <button disabled={loading}>
                            {loading ? 'CARGANDO...' : 'INICIAR SESIÓN'}
                        </button>
                        {/* {loading ?
                            <button style={{ backgroundColor: '#FFCDE3' }} disabled>CARGANDO...</button> :
                            <button>INICIAR SESIÓN</button>
                        } */}
                        <div className="contChangeOpt">
                            <span>¿Aún no tienes una cuenta?</span>
                            <span><Link to="/auth/register">Regístrate</Link></span>
                        </div>
                    </div>
                </form>
            </CardAccess>
        </div>
    )
}

export default LoginPage
